import React from "react";
import { Box, Typography } from "@mui/material";
import Lottie from "lottie-react";
import { useMaterialUIController } from "context";

const DashboardTopCard = ({ lottieicon, imgicon, label, count, bgcolor, onClick, disabled }) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        backgroundColor: darkMode ? "#202940" : "#F6F6F6",
        borderRadius: "20px",
        padding: "6px 12px",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        border: darkMode ? "" : "1px solid #E0E0E0",
        marginRight: "8px",
        gap: 1.5,
        cursor: "pointer",
        width: "fit-content",
        cursor: disabled ? "not-allowed" : "pointer",
        pointerEvents: disabled ? "none" : "auto",
        opacity: disabled ? 0.55 : 1,
        transition: "opacity 0.2s ease",


      }}
      onClick={!disabled ? onClick : undefined}
    >
      {/* Icon Placeholder */}
      <Box
        sx={{
          width: lottieicon ? "30px" : "28px",
          height: lottieicon ? "30px" : "28px",
          backgroundColor: imgicon && bgcolor,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",

        }}
      >
        {lottieicon &&
          <Lottie
            animationData={lottieicon}
            loop
            autoplay
            style=
            {{
              width: "100%",
              height: "100%",
              transform: "scale(2)",  // Increase the animation size
              transformOrigin: "center", // Ensure it scales from the center
            }}
          />
        }
        {
          imgicon &&
          <img
            src={imgicon}
            alt="icon"
            style={{ width: "18px", height: "18px", objectFit: "contain" }}
          />
        }
      </Box>

      {/* Text */}
      <Typography
        variant="body2"
        sx={{
          fontWeight: 400, whiteSpace: "nowrap",
          color: darkMode ? "#fff" : "#000",
        }}
      >
        {label} ({count})
      </Typography>
    </Box>
  );
};

export default DashboardTopCard;
